<template>
  <div class='toolbarContent'
    :class="{'menuActive': showSubMenus.apps || showSubMenus.myApps || showSubMenus.helpMenu}"
    ref="toolbarContent"
    id="toolbarContent">
    <div class="overlay" v-if="isOverlay"></div>

    <!-- GREY SITES -->
    <transition
      name="showMenu-fadeInLeft"
      enter-active-class="animated fadeInLeft"
      leave-active-class="animated fadeOutLeft">
      <grey-sites
        v-if="showSubMenus.apps"
        :apps="apps"
        :mobile="isToolbarHorizontal"
        @go-to-app="goToApp"
        @open-help="openHelp"
        @go-back="goBack"
        @close-greysites-menu="openSubmenu('close')"
      >
      </grey-sites>
    </transition>

    <!-- MY APPS -->
    <transition
      name="showMenu-fadeInLeft"
      enter-active-class="animated fadeInLeft"
      leave-active-class="animated fadeOutLeft">
      <my-apps
        v-if="showSubMenus.myApps"
        :mobile="isToolbarHorizontal"
        :isPhone="isPhone"
        @go-to-app="goToApp"
        @go-back="goBack"
        @close-myapps-menu="openSubmenu('close')"
      >
      </my-apps>
    </transition>

    <!-- HELP MENU -->
    <transition
      name="showMenu-fadeInLeft"
      enter-active-class="animated fadeInLeft"
      leave-active-class="animated fadeOutLeft"
    >
      <help-menu
        v-if="showSubMenus.helpMenu"
        :mobile="isToolbarHorizontal"
        @go-back="goBack"
        @close-help-menu="openSubmenu('close')"
      >
      </help-menu>
    </transition>

    <!-- DESKTOP MENU -->
    <div class="desktopVersion" v-if="!isToolbarHorizontal" id="toolDesktop">
      <section class="toolbarContent__items">
        <section class='toolbarContent__items--options'>
          <span class='toolbarContent__items_item icon-grey-appsMenuButton'
            :class="[showSubMenus.apps || showSubMenus.helpMenu ? 'itemActive' : '', allActive ? 'allActive' : ''] "
            title="Grey Sites and Tools"
            ref="greySitesButton">
          </span>
          <a :href="appConfig.apps_url.search" class='toolbarContent__items_item icon-grey-search'
            :class="[showSubMenus.search ? 'itemActive' : '', allActive ? 'allActive' : '']"
            title="Search"
            @click.stop.prevent="openSubmenu('search')"
            ref="searchButton">
          </a>
          <a 
            :href="appConfig.apps_url.collections"
            class='toolbarContent__items_item icon-grey-collectionsMenuButton'
            title="Collections">
          </a>
          <a
            :href='`${appConfig.apps_url.search}/uploadFile`'
            class="toolbarContent__items_item textDecorationNone"
            v-if="actionCanBePerformed('edit', 'uploadFilesRoot')"
          >
            <span class='icon-grey-upload-files'
              title="Upload File"
              ref="UploadFileRef">
            </span>
          </a>
        </section>
        <section class="toolbarContent__items--profileLogo">
          <div id="notificationsId" class="notifications">
            <span class="icon-grey-bell notifications__bell"
              title="Notifications"  
              :class="[showSubMenus.notificationsSubMenu ? 'active' : '', allActive ? 'allActive' : '']"
              @click="goToApp('notifications')">
              <span class="notifications__bell--number" v-if="webSockets.notificationsNew">{{notificationsLabel}}</span>
            </span>
            <notifications-sub-menu
              v-if="showSubMenus.notificationsSubMenu"
              :mobile="isToolbarHorizontal"
              :notificationsAll="notificationsAll"
              :viewAllUrl="appConfig.apps_url.notifications"
              @close-notifications-menu="closeNotificationsSubMenu"
              @splice-notifications="spliceNotification"
            >
            </notifications-sub-menu>
          </div>
          <span class="icon-grey-myApps myApps"
            v-if="actionCanBePerformed('read', 'myApps')"
            :class="[showSubMenus.myApps ? 'itemActive' : '', allActive ? 'allActive' : ''] "
            title="My Apps"
            ref="myAppsButton">
          </span>
          <section class='profilePicture'>
            <img :src="isTherePicture" class='profilePicture__image' :class="{'' : !allActive, 'profilePicture__image--active' : showSubMenus.profilePictureSubMenu}" @click="goToApp('profilePicture')">
            <profile-sub-menu
              :profilePictureSubMenu='showSubMenus.profilePictureSubMenu'
              @close-profile-menu="closeProfileSubMenu"
              :ecCode="ecCode"
              :mobile="isToolbarHorizontal"
              :role="role"
            >
            </profile-sub-menu>
          </section>
          <section class='greyLogo'>
            <a href="/" class='icon-grey-greyLogo greyLogo__logo' :class="{'' : !allActive}" @click.stop.prevent="goToApp('home')"></a>
          </section>
        </section>
      </section>
    </div>
    <!-- END DESKTOP MENU -->

    <!-- MAIN MENU MOBILE -->
    <div class="mobileVersion" id="toolMobile" v-else>
      <section class="toolbarContent__header">
        <section class="toolbarContent__header--logoProfile">
          <a href="/" class="logo" @click.stop.prevent="goToApp('home')">
            <span class="icon-grey-greyLogo"></span>
          </a>
          <section class='profilePicture'>
            <img :src="isTherePicture" class='profilePicture__image' :class="{'' : !allActive, 'profilePicture__image--active' :showSubMenus.profilePictureSubMenu}" @click="goToApp('profilePicture')">
            <profile-sub-menu
              :profilePictureSubMenu='showSubMenus.profilePictureSubMenu'
              @close-profile-menu="closeProfileSubMenu"
              :ecCode="ecCode"
              :mobile="isToolbarHorizontal"
              :role="role"
            >
            </profile-sub-menu>
          </section>
            <span class="icon-grey-myApps myApps"
              v-if="actionCanBePerformed('read', 'myApps')"
              :class="[showSubMenus.myApps ? 'itemActive' : '', allActive ? 'allActive' : ''] "
              title="My Apps"
              @click="openSubmenu('myApps')"
              ref="myAppsButton">
            </span>
        </section>
        <div class="toolbarContent__header--menu">
          <div id="notificationsId" class="notifications">
            <span class="icon-grey-bell"
              title="Notifications"  
              :class="[showSubMenus.notificationsSubMenu ? 'active' : '', allActive ? 'allActive' : '']"
              @click="goToApp('notifications')">
              <span class="notifications__bell--number" v-if="webSockets.notificationsNew">{{notificationsLabel}}</span>
            </span>
            <notifications-sub-menu
              v-if="showSubMenus.notificationsSubMenu"
              mobile
              class="notifications__subMenu"
              :notificationsAll="notificationsAll"
              :viewAllUrl="appConfig.apps_url.notifications"
              @close-notifications-menu="closeNotificationsSubMenu"
              @splice-notifications="spliceNotification"
            >
            </notifications-sub-menu>
          </div>
          <a 
            :href="appConfig.apps_url.collections" 
            class='item icon-grey-collectionsMenuButton toolbarContent__header_item'
            title="Collections">
          </a>
          <a :href="appConfig.apps_url.search" class='item icon-grey-search toolbarContent__header_item'
            :class="[showSubMenus.search ? 'itemActive' : '', allActive ? 'allActive' : '']"
            title="Search"
            @click.stop.prevent="openSubmenu('search')"
            ref="searchButton">
          </a>
          <span class='item icon-grey-appsMenuButton toolbarContent__header_item'
            :class="[showSubMenus.apps || showSubMenus.helpMenu ? 'itemActive' : '', allActive ? 'allActive' : ''] "
            title="Grey Sites and Tools"
            @click="openSubmenu('apps')"
            ref="greySitesButton">
          </span>
        </div>
      </section>
    </div>

    <mobileMenu class="toolbarContent__mobileMenu" @menuClicked="openSubmenu($event)"></mobileMenu>
    <!-- END MOBILE MENU -->
  </div>
</template>

<script>

import { reactive, ref, onMounted, computed, onUnmounted } from 'vue'
import greySites from '../greySites/greySites'
import helpMenu from '../helpMenu/helpMenu'
import profileSubMenu from '../profileSubMenu/profileSubMenu'
import { getCountPerApp, initUserProcesses, openConnectionWs, startConnection, loadNotifications, getProfilePicture } from '../../services'
import interceptors from '../../utils/interceptors'
import configEndPoints from '../../config.json'
import myApps from '../myApps/myApps'
import defineAbilitiesFor from '../../utils/abilities'
import notificationsSubMenu from '../notificationsSubMenu/notificationsSubMenu'
import { formatTimeAgo } from '../../utils'
import mobileMenu from '../mobileMenu/mobileMenu/mobileMenu'

export default {
  name: 'toolbar',
  props: {
    user: {
      type: String
    },
    app: {
      type: String
    },
    ecCode: {
      type: String
    },
    email: {
      type: String
    },
    role: {
      type: Array
    }
  },
  components: {
    greySites,
    helpMenu,
    myApps,
    profileSubMenu,
    notificationsSubMenu,
    mobileMenu
  },
  setup (props, { emit }) {
    const showSubMenus = reactive({
      apps: false,
      search: false,
      helpMenu: false,
      mainMobile: false,
      myApps: false,
      profilePictureSubMenu: false,
      notificationsSubMenu: false
    })
    const apps = ref({})
    const webSockets = reactive({
      connection: null,
      notificationsNew: 0
    })
    const notificationsAll = reactive({
      new: [],
      earlier: []
    })
    const allActive = ref(true)
    const isToolbarHorizontal = ref(null)
    const isOverlay = ref(false)
    const enterApp = ref('')
    const appConfig = reactive(configEndPoints)
    const abilities = defineAbilitiesFor(props.role)
    const toolbarContent = ref(null)
    const greySitesButton = ref(null)
    const searchButton = ref(null)
    const myAppsButton = ref(null)
    const profilePicture = ref('')
    const isPhone = ref(false)

    onUnmounted(() => {
      document.removeEventListener('click', clearProfileSubmenuOnBlur)
    })

    onMounted(() => {
      loadProfilePicture()
      setUpWebSocket()
      interceptors.setupLocal()
      resizeSetUp()
      handleResize()
      toolbarWorkFlow()
      intoApp(props.app)
      getAppCount()
      initUserProcesses()
      document.addEventListener('click', clearProfileSubmenuOnBlur)
    })

    /**
     * @description Set profile picture or placeholder
     */

    const isTherePicture = computed(() => {
      return profilePicture.value ? profilePicture.value : require('../../assets/avatar.jpg')
    })

    /**
     * @description Set notifications number label
     */
    const notificationsLabel = computed(() => {
      return webSockets.notificationsNew > 9 ? '9+' : webSockets.notificationsNew
    })

    /**
     * @description Obtain count of items for each app
     */
    function getAppCount () {
      getCountPerApp().then(
        (response) => {
          apps.value = [
            {
              name: 'Home',
              icon: 'GoGrey'
            },
            ...response.data.sites.map(site => ({
              ...site,
              icon: site.name
            })),
            ...response.data.tools.map(tool => ({
              ...tool,
              icon: tool.name
            })),
            {
              name: 'Centers of Excellence',
              icon: 'coe'
            },
            {
              name: 'line'
            },
            {
              name: 'Help',
              icon: 'help',
              rightIcon: 'arrowRight'
            }
          ]
          const workIndex = apps.value.map(app => app.name).indexOf('Work')
          apps.value.splice(workIndex + 1, 0, { name: 'Borderless Opportunities', icon: 'opportunity' })
        },
        (error) => {
          console.error(error)
        }
      )
    }

    /**
     * @description Close menu and return last menu
     * @param menuClose Menu the user is going to close
     */
    function goBack (menuClose) {
      setTimeout(() => {
        switch (menuClose) {
          case 'apps':
            showSubMenus.mainMobile = true
            showSubMenus.apps = showSubMenus.myApps = false
            break
          case 'help':
          case 'myApps':
            showSubMenus.apps = true
            showSubMenus.helpMenu = false
            showSubMenus.myApps = false
            break
        }
      })
    }

    /**
     * @description Go app selected
     * @param appName Name app
     */
    function goToApp (appName) {
      hideAllSubMenu()
      appName = appName === 'People Finder' ? 'people' : appName
      appName = appName === 'notifications' ? window.innerWidth < 415 ? 'notificationsPage' : 'notifications' : appName
      setTimeout(() => {
        switch (appName) {
          case 'Home':
            window.open(appConfig.apps_url.gogrey, '_self')
            break
          case 'Culture Daily':
            window.open(appConfig.apps_url.cultureDaily)
            break
          case 'Office 365':
            window.open(appConfig.apps_url.office)
            break
          case 'Work':
            location.href = appConfig.apps_url.work
            break
          case 'Intelligence':
            location.href = appConfig.apps_url.intelligence
            break
          case 'people':
            location.href = appConfig.apps_url.people
            break
          case 'News':
            location.href = appConfig.apps_url.news
            break
          case 'Centers of Excellence':
            window.open(appConfig.apps_url.theHive)
            break
          case 'profilePicture':
            showSubMenus.profilePictureSubMenu = !showSubMenus.profilePictureSubMenu
            break
          case 'notifications':
            if (showSubMenus.notificationsSubMenu) {
              closeNotificationsSubMenu()
            } else {
              showNotificationsModal()
            }
            break
          case 'notificationsPage':
            webSockets.notificationsNew = 0
            loadNotifications().then(_ => location.href = appConfig.apps_url.notifications)
            break
          case 'home':
            window.location.href = '/'
            break
          case 'Borderless Opportunities':
            location.href = appConfig.apps_url.opportunities
            break
        }
      }, 100)
    }

    /**
     * @description Load notifications list and display modal
     */
    function showNotificationsModal () {
      webSockets.notificationsNew = 0
      webSockets.connection.stop()
      loadNotifications().then(
        (response) => {
          const mapNotificationsAll = [
            ...response.data.map(notification => ({
              ...notification,
              formattedTimeAgo: formatTimeAgo(notification.notificationDate)
            }))
          ]
          notificationsAll.new = mapNotificationsAll.filter(notification => notification.isNew)
          notificationsAll.earlier = mapNotificationsAll.filter(notification => !notification.isNew)
          showSubMenus.notificationsSubMenu = !showSubMenus.notificationsSubMenu
        },
        (error) => {
          console.error(error)
        }
      )
    }

    /**
     * @description hide all sub menus
     */
    function hideAllSubMenu () {
      showSubMenus.apps =
      showSubMenus.search =
      showSubMenus.myApps =
      isOverlay.value =
      showSubMenus.helpMenu = false
      allActive.value = true
    }

    /**
     * @description Which one is the app that user is entering
     * @param appName app's name
     */
    function intoApp (appName) {
      switch (appName) {
        case 'news':
          enterApp.value = 'news'
          break
        case 'in':
          enterApp.value = 'in'
          break
        case 'pf':
          enterApp.value = 'pf'
          break
        case 'go':
          enterApp.value = 'go'
          break
        case 'search':
          enterApp.value = 'search'
          break
        default:
          enterApp.value = ''
      }
    }

    /**
     * @description Get info when user into the web.
     * It will let us to know if the device is mobile or no
     */
    function isMobile () {
      return navigator.userAgent.match(/Android|iPhone|iPad/i)
    }

    /**
     * @description Open help menu
     */
    function openHelp () {
      showSubMenus.apps = false
      isOverlay.value = false
      window.open(appConfig.apps_url.help, '_blank')
    }

    /**
     * @description Show or hide menu selected by user on mobile version
     * @param subMenu Type of menu will show
     */
    function openSubmenu (subMenu) {
      switch (subMenu) {
        case 'close':
          showSubMenus.mainMobile = showSubMenus.apps = showSubMenus.myApps = showSubMenus.helpMenu = false
          break
        case 'mainMobile':
          showSubMenus.mainMobile = !showSubMenus.mainMobile
          break
        case 'apps':
          showSubMenus.apps = !showSubMenus.apps
          showSubMenus.mainMobile = false
          break
        case 'search':
          window.location.href = appConfig.apps_url.search
          break
        case 'collections':
          window.location.href = appConfig.apps_url.collections
          break
        case 'myApps':
          showSubMenus.myApps = !showSubMenus.myApps
          showSubMenus.mainMobile = false
          break
      }
    }

    /**
     * @description verify is there are some modal open, else close all
     */
    function verifyModals (e) {
      if (e.target.className.indexOf('btn-close') !== -1) {
        hideAllSubMenu()
      } else if (e.target.className.indexOf('btn-apply') !== -1) {
        if (isMobile() || window.innerWidth < 1024) {
          openSubmenu('close')
        } else {
          hideAllSubMenu()
        }
      } else if (e.target.className.indexOf('btn-backArrow') !== -1) {
        openSubmenu('mainMobile')
      }
    }

    /**
     * @description Close Profile Sub Menu
     */
    function closeProfileSubMenu () {
      showSubMenus.profilePictureSubMenu = false
    }

    /**
     * @description Close notifications Sub Menu
     */
    function closeNotificationsSubMenu () {
      showSubMenus.notificationsSubMenu = false
      startConnection(webSockets.connection)
    }

    /**
     * @description Clear and hide the profile submenu when user clicks outside the image
     */
    function clearProfileSubmenuOnBlur (event) {
      setTimeout(() => {
        if (showSubMenus.apps || showSubMenus.myApps || showSubMenus.helpMenu) {
          document.querySelector('#app').style.cssText = 'overflow: hidden;'
        } else {
          document.querySelector('#app').style.cssText = ''
        }
      }, 200)
    }

    /**
     * @description Validate if an action can be performed by the current user
     * @param action Action to be performed
     * @param resource Resource of the app
     */
    function actionCanBePerformed (action, resource) {
      return abilities.can(action, resource)
    }

    /**
     * @desciption Setup connection with Web Socket
     */
    function setUpWebSocket () {
      webSockets.connection = openConnectionWs()
      startConnection(webSockets.connection)
      webSockets.connection.on(
        'notify',
        (message) => {
          webSockets.notificationsNew = webSockets.notificationsNew + message.count
        }
      )
    }

    /**
     * @description Handler to know the size of the screen
     */
    function handleResize () {
      window.addEventListener('resize', function (e) {
        resizeSetUp()
      })
    }

    /**
     * @description Setup resize handle to know the size of the screen
     */
    function resizeSetUp () {
      if (isMobile() || window.innerWidth < 1024) {
        isToolbarHorizontal.value = true
        isOverlay.value = false
      } else {
        isToolbarHorizontal.value = false
        if (showSubMenus.apps || showSubMenus.helpMenu || showSubMenus.myApps) {
          isOverlay.value = true
        }
      }
      if (toolbarContent.value.nextElementSibling) {
        toolbarContent.value.nextElementSibling.classList.remove('display-none')
      }
      isPhone.value = window.innerWidth <= 575
    }

    /**
     * @description splice notification array
     * @param title Typd of notification { New - Earlier }
     * @param index Position of array to splice
     * @param number of position will cut array
     */
    function spliceNotification (config) {
      notificationsAll[config.title.toLowerCase()].splice(config.index, config.number)
    }

    /**
     * @description Just to close the menu if the user click outside it.
     * @param e event DOM properties
     */
    function toolbarWorkFlow () {
      window.addEventListener('click', function (e) {
        if (!isMobile() && window.innerWidth >= 1024) {
          switch (e.target.title) {
            case 'Grey Sites and Tools':
              if (!showSubMenus.helpMenu) {
                showSubMenus.apps = !showSubMenus.apps
                isOverlay.value = showSubMenus.apps
                allActive.value = showSubMenus.search = showSubMenus.myApps = false
              } else {
                hideAllSubMenu()
              }
              break
            case 'My Apps':
              showSubMenus.myApps = !showSubMenus.myApps
              isOverlay.value = showSubMenus.myApps
              allActive.value = showSubMenus.search = showSubMenus.apps = showSubMenus.helpMenu = false
              break
            default:
              if (document.getElementById('greySites')) {
                if (!document.getElementById('greySites').contains(e.target)) {
                  hideAllSubMenu()
                }
              } else if (document.getElementById('helpMenu')) {
                if (!document.getElementById('helpMenu').contains(e.target)) {
                  hideAllSubMenu()
                }
              } else if (document.getElementById('myApps')) {
                if (!document.getElementById('myApps').contains(e.target)) {
                  hideAllSubMenu()
                }
              } else {
                hideAllSubMenu()
              }
          }
          allActive.value = !showSubMenus.apps && !showSubMenus.myApps && !showSubMenus.search && !showSubMenus.helpMenu ? true : allActive.value
          verifyModals(e)
        } else {
          verifyModals(e)
        }
      })
    }

    /**
     * @description Loads profile picture
     */
    function loadProfilePicture () {
      if (localStorage.getItem('loginSession.profile')) profilePicture.value = localStorage.getItem('loginSession.profile')
      emit('toolbarLoaded')
      getProfilePicture(props.ecCode).then(
        (response) => {
          localStorage.setItem('loginSession.profile', response.data.url ? response.data.url : '')
          profilePicture.value = localStorage.getItem('loginSession.profile')
        },
        (error) => {
          console.error(error)
        }
      )
    }

    /**
     * @description Refreshes profile picture when a new profile picture is uploaded
     * @param url new image url sent by BE after image update
     */
    function refreshImage(url) {
      localStorage.setItem('loginSession.profile', url)
      profilePicture.value = localStorage.getItem('loginSession.profile')
    }

    return {
      onUnmounted,
      onMounted,
      appConfig,
      notificationsAll,
      isTherePicture,
      goBack,
      goToApp,
      notificationsLabel,
      openHelp,
      closeProfileSubMenu,
      actionCanBePerformed,
      toolbarContent,
      webSockets,
      isToolbarHorizontal,
      showSubMenus,
      apps,
      allActive,
      isOverlay,
      hideAllSubMenu,
      greySitesButton,
      searchButton,
      myAppsButton,
      openSubmenu,
      closeNotificationsSubMenu,
      spliceNotification,
      isPhone,
      refreshImage
    }
  }
}
</script>

<style lang='scss' src='./toolbar.scss'>
</style>
